import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { bearerToken } from './common/auth.service';
import { urls as apis } from './apiUrls';
import { httpOptions } from './common/common.service';

import { HttpErrorHandler, HandleError } from './common/http-error-handler.service';


@Injectable()
export class SitesDetailsService {	
	private handleError: HandleError;

	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
		this.handleError = httpErrorHandler.createHandleError('SitesDetailsService');
	}

	getSiteDetails(siteId : string | null): Observable<any> {
		return this.http
			.get(apis.siteDetailsUrl.replaceAll("{id}", `${siteId}`), httpOptions)
			.pipe(catchError(this.handleError('getSiteDetails', {})));
	}

	getSiteAnnualgradeTrend(siteId : string, asTextOrCSV = false) : Observable<any> {
		let options : any = httpOptions;
		if(options && asTextOrCSV)
		{
			options = {   
				headers : new HttpHeaders({
					"Content-Type": "application/json",
					"Accept": "text/csv"					
				}),
				responseType : "text"
			}
		}
		const params = { id : siteId };
		return this.http
			.get(apis.trendAnnualgradeUrl, { params : params, ...options})
			.pipe(catchError(this.handleError('getSiteAnnualgradeTrend', {})));
	}

	getSiteEnterococciTrend(siteId : string, council = "", region = "", siteType = "", asTextOrCSV = false,startPeriod = 0, endPeriod = 253385374611 ) : Observable<any> {
		let options : any = httpOptions;
		if(options && asTextOrCSV)
		{
			options = {   
				headers : new HttpHeaders({
					"Content-Type": "application/json",
					"Accept": "text/csv"					
				}),
				responseType : "text"
			}
		}
		const params = { id : siteId, start_period : startPeriod, end_period : endPeriod };
		return this.http
			.get(apis.trendEnterococciUrl, { params : params, ...options})
			.pipe(catchError(this.handleError('getSiteTrendEnterococci', {})));
	}
	

	getSiteWatertempTrend(siteId : string, council = "", region = "", siteType = "", asTextOrCSV = false) : Observable<any> {
		let options : any = httpOptions;
		if(options && asTextOrCSV)
		{
			options = {   
				headers : new HttpHeaders({
					"Content-Type": "application/json",
					"Accept": "text/csv"					
				}),
				responseType : "text"
			}
		}
		const params = { id : siteId };
		return this.http
			.get(apis.trendWatertempUrl, { params : params, ...options})
			.pipe(catchError(this.handleError('getSiteWatertempTrend', {})));
	}

	getSiteRainfallTrend(siteId : string, council = "", region = "", siteType = "", asTextOrCSV = false) : Observable<any> {
		let options : any = httpOptions;
		if(options && asTextOrCSV)
		{
			options = {   
				headers : new HttpHeaders({
					"Content-Type": "application/json",
					"Accept": "text/csv"					
				}),
				responseType : "text"
			}
		}
		const params = { id : siteId };
		return this.http
			.get(apis.trendRainfallUrl, { params : params, ...options})
			.pipe(catchError(this.handleError('getSiteRainfallTrend', {})));
	}	
}
